module.exports = __webpack_public_path__ + "static/media/fvs_valve1_59.2a44ed21.jpg";